var map = {
	"./get-android-direct.png": "03f8",
	"./get-cafe-bazzar.png": "192b",
	"./get-google-play.png": "b016",
	"./get-iphone.png": "ae14",
	"./get-linux.png": "a8ad",
	"./get-web.png": "e727",
	"./get-windows.png": "52b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61e7";